import { storageHelper, User } from '@spo/logic';
import { createContext, ReactNode, useContext } from 'react';

type RolesContextType = {
  hasRoleVisualization: boolean;
  hasRoleProductLeader: boolean;
  hasRoleSportLeader: boolean;
};

const RolesContext = createContext<RolesContextType | undefined>(undefined);

type RolesProviderProps = {
  children: ReactNode;
};

export enum RolesWhiteList {
  SPO_VISUALIZATION = 'SPO_OFFER_VISUALISATION',
  SPO_PRODUCT_LEADER = 'SPO_PRODUCT_LEADER',
  SPO_INTERNATIONAL_SPORT_LEADER = 'SPO_INTERNATIONAL_SPORT_LEADER',
  ADMIN = 'SPO_ADMIN_SUPPORT',
}

export const RolesProvider = ({ children }: RolesProviderProps) => {
  const user = storageHelper.getItem<User>('user');
  const userRoles = user?.roles || [];

  const isAdmin = userRoles.includes(RolesWhiteList.ADMIN);
  const isProductLeader = userRoles.includes(RolesWhiteList.SPO_PRODUCT_LEADER);
  const isSportLeader = userRoles.includes(
    RolesWhiteList.SPO_INTERNATIONAL_SPORT_LEADER,
  );
  const isViewer = userRoles.includes(RolesWhiteList.SPO_VISUALIZATION);

  return (
    <RolesContext.Provider
      value={{
        hasRoleVisualization: isViewer || isAdmin,
        hasRoleProductLeader: isProductLeader || isAdmin,
        hasRoleSportLeader: isSportLeader || isAdmin,
      }}
    >
      {children}
    </RolesContext.Provider>
  );
};

export const useRoles = () => {
  const context = useContext(RolesContext);
  if (!context) {
    throw new Error('useRoles must be used within a RolesProvider');
  }
  return context;
};
